module.exports = __webpack_public_path__ + "img/attention_icon.05ee4323.svg";